import { render, staticRenderFns } from "./Mikepad.vue?vue&type=template&id=4360182c&scoped=true&"
import script from "./Mikepad.vue?vue&type=script&lang=js&"
export * from "./Mikepad.vue?vue&type=script&lang=js&"
import style0 from "./Mikepad.vue?vue&type=style&index=0&id=4360182c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4360182c",
  null
  
)

export default component.exports